// extracted by mini-css-extract-plugin
module.exports = {"txt":"components-Label-Label__txt--2G1SW","myspan":"components-Label-Label__myspan--3UVvA"};